<template>
  <NuxtLink :to="`/insider/${id}`" class="flex group flex-col md:gap-4 gap-2.5 border-b pb-4 border-b-gray-500">
    <div class="overflow-hidden h-[max(21vw,238px)] relative" style="contain: layout style paint">
      <AtomImage
        class="w-full hover:scale-105 will-change-transform duration-500 h-full object-cover"
        :strapi-image-object="image"
      />
      <div
        v-if="category?.length != 0"
        class="flex flex-wrap z-10 absolute left-2.5 top-2.5 items-center gap-2"
        style="contain: layout"
      >
        <AtomTag
          v-for="tag in category"
          :key="tag.id"
          tag="span"
          class="bg-white relative !shadow-none border-[1px] before:absolute before:-inset-1 before:translate-y-full before:duration-300 before:bg-gray-100 group-hover:text-white group-hover:bg-gray-100 group-hover:before:translate-y-0"
          :content="tag.title"
        />
      </div>
    </div>
    <div :class="{ 'hidden md:flex': view == 'home', flex: view != 'home' }" class="flex justify-between gap-2">
      <p class="text-xs text-gray-400">
        {{ new Date(date).toLocaleDateString('ru-RU', { dateStyle: 'long' }).slice(0, -3) }}
      </p>
      <p class="text-xs text-gray-400">{{ duration }}</p>
    </div>
    <p class="md:text-[20px] tracking-[-.02em] grow text-base leading-[125%]">{{ title }}</p>
  </NuxtLink>
</template>

<script>
import AtomImage from '../atoms/AtomImage.vue'
import AtomTag from '../atoms/AtomTag.vue'

export default {
  name: 'InsightPreview',
  components: { AtomImage, AtomTag },
  props: ['category', 'title', 'date', 'image', 'duration', 'id', 'view'],
}
</script>
